import i18next from 'i18next';

i18next.addResources('en', 'URLsGeneratedModal', {
  title: 'URLs generated',
  description: 'A link to the file with the URLs has been sent via email.',
  confirm: 'Confirm'
});
